<template>
  <a-card id="apply">
    <div :class="advanced ? 'search' : null">
      <a-form layout="inline" class="searchForm">
        <a-form-item label="应用名称">
          <a-input :maxLength="30" placeholder="请输入应用名称" v-model="Name" />
        </a-form-item>
        <a-form-item style="margin-right: 35px">
          <a-button type="primary" @click="getList(1)">查询</a-button>
          <a-button style="margin-left: 8px" @click="resetSearch()">重置</a-button>
        </a-form-item>
        <a-form-item>
          <a-button v-permission="`Auth.Application.Add`" @click="addNew" icon="plus" type="primary">添加应用 </a-button>
          <a-button v-permission="`Auth.Application.DeleteAll`" style="margin-left: 15px" @click="batchDelete" icon="delete" type="danger">批量删除 </a-button>
        </a-form-item>
        <!--<span style="float: right; margin-top: 3px;">

          <a @click="toggleAdvanced" style="margin-left: 8px" v-if="istoggleAdvanced">
            {{advanced ? '收起' : '展开'}}
            <a-icon :type="advanced ? 'up' : 'down'"/>
          </a>
        </span>-->
      </a-form>
    </div>
    <div style="margin-top: 15px">
      <standard-table
        :columns="columns"
        rowKey="id"
        :loading="loading"
        :dataSource="dataSource"
        :selectedRows.sync="selectedRows"
        @selectedRowChange="onSelectChange"
        :pagination="{
          current: pageIndex,
          pageSize: pageSize,
          total: total,
          showSizeChanger: true,
          showQuickJumper: true,
          showLessItems: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onPageChange,
          onShowSizeChange: onSizeChange,
        }"
      >
        <div slot="type" slot-scope="{ text }">
          <span v-if="text == 0" style="color: #ff5722">中后台应用</span>
          <span v-if="text == 1" style="color: #009688">第三方应用</span>
          <span v-if="text == 2" style="color: #2455e8">用户端应用</span>
          <span v-if="text == 3" style="color: #b92c3b">Saas应用</span>
        </div>
        <div v-auth="`Auth.Application.Status`" slot="enabled" slot-scope="{ text }">
          <a-switch @change="updateStatus(text)" v-model="text.enabled" checked-children="启用" un-checked-children="禁用" />
        </div>
        <div slot="action" slot-scope="{ text, record }">
          <a v-permission="`Auth.Application.Edit`" style="margin-right: 8px" @click="edit(record)">
            <a-icon type="edit" />
            编辑
          </a>
          <a-popconfirm v-permission="`Auth.Application.Delete`" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="deleteRecord(record)">
            <a style="color: #f00; margin-right: 8px">
              <a-icon type="delete" />
              删除
            </a>
          </a-popconfirm>
          <!-- v-permission="`/settings/Apply/Sysapplicationmodule`" -->
          <a @click="gomodule(record)" v-permission="`/settings/Apply/Sysapplicationmodule`" :style="`margin-right: 8px;${record.type === 1 && 'color: #bbb;'}`">
            <a-icon type="database" />
            模块管理
          </a>
        </div>
      </standard-table>
    </div>
    <a-modal v-model="addvisible" :title="addModelTitle" @ok="handleOk" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item ref="name" label="应用名称" prop="name">
          <a-input @change="(e) => (form.name = e.target.value.replace(/\s*/g, ''))" v-model="form.name" placeholder="请输入应用名称" />
        </a-form-model-item>
        <a-form-model-item ref="description" label="描述">
          <a-textarea v-model="form.description" placeholder="请输入描述" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="enabled">
          <a-radio-group v-model="form.enabled">
            <a-radio :value="true">启用</a-radio>
            <a-radio :value="false">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="应用类型" prop="type">
          <a-radio-group v-model="form.type">
            <a-radio :value="0">平台应用</a-radio>
            <a-radio :value="1">第三方应用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="所属机构" prop="organizationId" v-if="form.type == 1">
          <a-select v-model="form.organizationId" option-filter-prop="children" show-search placeholder="请选择机构">
            <a-select-option :value="item.id" v-for="item in orgList" :key="item.id">{{ item.name }} </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import StandardTable from '@/components/table/StandardTable'

const columns = [
  {
    title: '应用名称',
    dataIndex: 'name',
    width: 220,
    ellipsis: true,
    align: 'center',
  },
  {
    title: '应用类型',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
    align: 'center',
  },
  {
    title: '客户端id',
    dataIndex: 'clientId',
    align: 'center',
    // scopedSlots: {customRender: "type"},
  },
  {
    title: '所属机构',
    dataIndex: 'organizationName',
    align: 'center',
  },
  {
    title: '描述',
    dataIndex: 'remark',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'enabled' },
    width: 120,
    align: 'center',
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
    width: 250,
    align: 'center',
  },
]

export default {
  name: 'Apply',
  components: { StandardTable },
  data() {
    return {
      advanced: false,
      columns: columns,
      dataSource: [],
      selectedRows: [],
      loading: true,
      orgList: [],
      checkedList: [],
      istoggleAdvanced: false, //是否显示展开按钮
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      addvisible: false,
      addoredit: 'add', //类型   add为新增
      editId: '',
      enabledText: '',
      Name: '',
      visible: false,
      condition: true,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      other: '',
      addModelTitle: '添加应用',
      form: {
        name: '',
        description: '',
        enabled: true,
        type: 0,
        organizationId: undefined,
        isRecommend: false,
      },
      rules: {
        name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          { min: 4, max: 20, message: '应用名称长度为 4 到 20 个字符', trigger: 'blur' },
        ],
        description: [{ required: true, message: '请输入模块描述', trigger: 'blur' }],
        enabled: [{ required: true, message: '请选择应用状态', trigger: 'change' }],
        type: [{ required: true, message: '请选择应用类型', trigger: 'change' }],
        organizationId: [{ required: true, message: '请选择机构名称', trigger: 'change' }],
      },
    }
  },
  // authorize: {
  //   deleteRecord: "delete"
  // },
  created() {
    this.getList()
  },
  activated() {
    this.getList()
  },
  methods: {
    getList(index) {
      let params = {
        PageIndex: index || this.pageIndex,
        PageSize: this.pageSize,
        Name: this.Name,
      }
      this.$http.applicationPageList(params).then((res) => {
          this.dataSource = res.data.data.items
          this.pageIndex = res.data.data.pageIndex
          this.total = res.data.data.totalCount
          this.loading = false
      })
    },
    resetSearch() {
      this.Name = ''
      this.getList(1)
    },
    // 获取机构
    getSelect() {
      this.$http.loadAllByType({ isOnlySuperior: false }).then((res) => {
          this.orgList = res.data.data
      })
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    onSelectChange(keys, rows) {
      this.checkedList = keys
    },
    addNew() {
      this.addvisible = true
      this.addoredit = 'add'
      this.addModelTitle = '添加应用'
      !this.orgList.length && this.getSelect()
    },
    edit(record) {
      this.addModelTitle = '编辑应用'
      this.addvisible = true
      this.addoredit = 'edit'
      this.form.name = record.name
      this.form.enabled = record.enabled
      this.form.type = record.type
      this.form.organizationId = record.organizationId || undefined
      this.form.description = record.remark
      this.editId = record.id
      !this.orgList.length && this.getSelect()
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            name: this.form.name,
            type: this.form.type,
            remark: this.form.description,
            enabled: this.form.enabled,
            organizationId: this.form.organizationId ? this.form.organizationId : '',
          }
          if (this.addoredit == 'add') {
            this.addData(params)
          } else {
            this.editData(params)
          }
        } else {
          return false
        }
      })
    },
    // 新增请求接口
    addData(params) {
      this.$http.addApplication(params).then((res) => {
          this.addvisible = false
          this.getList()
          this.$message.success('添加成功')
          this.resetForm()
   
      })
    },
    // 修改请求接口
    editData(params) {
      let query = params
      params.id = this.editId
      this.$http.editApplication(params).then((res) => {
          this.addvisible = false
          this.getList()
          this.$message.success('修改成功')
          this.resetForm()
      
      })
    },
    // 删除
    deleteRecord(record) {
      // let params = this.checkedList
      let params = [record.id]
      this.$http.deleteApplication(params).then((res) => {
          this.getList()
          this.$message.success('删除成功')
      
      })
    },
    // 批量删除
    batchDelete() {
      this.$message.destroy()
      const that = this
      if (this.checkedList.length) {
        this.$confirm({
          title: '确认删除选中的应用？',
          okType: 'danger',
          centered: true,
          onOk() {
            let params = that.checkedList
            that.$http.deleteApplication(params).then((res) => {
                if (that.dataSource.length > that.checkedList.length) {
                } else {
                  that.pageIndex = 1
                }
                that.getList()
                that.$message.success('删除成功')
                that.checkedList = []
            
            })
          },
        })
      } else {
        this.$message.warning('请选择应用')
      }
    },
    // 修改状态
    updateStatus(record) {
      this.$http.updateStatus(record).then((res) => {
          this.addvisible = false
          this.getList()
          this.$message.success('修改成功')
          this.resetForm()
       
      })
    },
    handleCancel() {
      this.$refs.ruleForm.resetFields()
      this.resetForm()
    },
    resetForm() {
      this.form.name = ''
      this.form.enabled = true
      this.form.type = 0
      this.form.organizationId = undefined
      this.form.description = ''
    },
    onPageChange(pageIndex, size) {
      this.pageIndex = pageIndex
      this.getList()
    },
    onSizeChange(pageIndex, size) {
      this.pageIndex = 1
      this.pageSize = size
      this.getList()
    },
    gomodule(record) {
      if (record.type !== 1)
        this.$router.push({
          path: '/settings/Apply/sysapplicationmodule',
          query: {
            id: record.id,
            name: record.name,
            type: record.type,
          },
        })
    },
  },
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 54px;
}

.fold {
  width: calc(100% - 216px);
  display: inline-block;
}

.operator {
  margin-bottom: 18px;
}

/deep/ .standard-table .alert {
  display: none !important;
}

.searchForm {
  display: flex;
  /deep/ .fold {
    width: 22%;
    display: flex;
  }
}

@media screen and (max-width: 900px) {
  .fold {
    width: 100%;
  }
}
</style>
